module.exports = __webpack_public_path__ + "static/media/jcb-logo.5e1cf5c6.svg";